import clsx from "clsx"
import { useContext } from "react"

import { faIcon } from "@utils/faIcon"

import { ExtraTouchArea } from "@particles/index"

import { IconButton, Tooltip } from "@atoms"

import { PopoverContext } from "@molecules/Popover/Popover"

import styles from "./PopoverHeaderCloseButton.module.scss"
import type { PopoverHeaderCloseButtonProps } from "./PopoverHeaderCloseButton.types"

export default function PopoverHeaderCloseButton(props: PopoverHeaderCloseButtonProps) {
    const { className, onClick, "aria-label": ariaLabel, isTabbable, icon, iconOnActive, isPressed } = props
    const { isOpen, setIsOpen } = useContext(PopoverContext)

    const onCloseClick = () => {
        if (onClick) {
            onClick()
        } else {
            setIsOpen(false)
        }
    }

    return (
        <div className={styles.base}>
            <Tooltip body="Close" wrapChildren={true}>
                <ExtraTouchArea extraTouchArea={8}>
                    <IconButton
                        size="md"
                        variant="muted"
                        className={clsx(styles.iconButton, className)}
                        aria-label={ariaLabel || "Close"}
                        icon={icon || faIcon({ name: "xmark", style: "regular" })}
                        iconOnActive={iconOnActive || faIcon({ name: "xmark", style: "solid" })}
                        iconIsActive={Boolean(isPressed)}
                        onClick={onCloseClick}
                        isTabbable={isTabbable ?? Boolean(isOpen)}
                        isPressed={isPressed}
                        noDebounce={true}
                    />
                </ExtraTouchArea>
            </Tooltip>
        </div>
    )
}
